import isEmpty from 'lodash/isEmpty';
import { useState, useEffect } from 'react';

import { Box, Icon, ClipboardButton, Banner } from '@numbox/components';
import { formatPhoneNumber } from '@numbox/util';

export const ReleaseHubHeader = () => {
  const [releaseData, setReleaseData] = useState<{
    email: string;
    mdn: string;
  } | null>(null);

  useEffect(() => {
    async function fetchReleaseData() {
      try {
        const response = await fetch('/debug/release_demo_data');
        if (response.ok) {
          const data = await response.json();
          setReleaseData(data);
        } else {
          console.log(response.statusText);
        }
      } catch (error) {
        console.log(error);
      }
    }

    if (window.location.href.includes('release.numa.dev')) {
      fetchReleaseData();
    }
  }, [setReleaseData]);

  if (isEmpty(releaseData)) {
    return null;
  }

  return (
    <Banner color="warning">
      <Box
        sx={{
          display: 'flex',
          gap: 3,
          alignItems: 'center',
        }}
      >
        {releaseData?.email && (
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              alignItems: 'center',
            }}
          >
            <Icon>person</Icon>
            <Box>{releaseData?.email}</Box>
            <ClipboardButton color="inherit" toCopy={releaseData?.email} />
          </Box>
        )}
        {releaseData?.mdn && (
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              alignItems: 'center',
            }}
          >
            <Icon>phone</Icon>
            <Box>{formatPhoneNumber(releaseData?.mdn)}</Box>
          </Box>
        )}
      </Box>
    </Banner>
  );
};
